import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const ProductsList = lazy(() => import('../../container/pages/ProductsList'));
const ProductsAdd = lazy(() => import('../../container/pages/ProductsAdd'));
const ProductsEdit = lazy(() => import('../../container/pages/ProductsEdit'));

const ProductRoute = () => {
  return (
    <Routes>
      <Route path="list" element={<ProductsList />} />
      <Route path="add" element={<ProductsAdd />} />
      <Route path="edit/:productId" element={<ProductsEdit />} />
      <Route path="*" element={<ProductsEdit />} />
    </Routes>
  );
};

export default ProductRoute;
